









import { Component, Prop, Vue } from "vue-property-decorator";
import { InputOption } from "@baklavajs/plugin-options-vue";

@Component({
    components: {
        DarkInput: InputOption
    }
})
export default class InterfaceView extends Vue {

    @Prop()
    name!: string;

    editmode = false;
    tempname = "";

    toggle() {
        if (!this.editmode) {
            this.tempname = this.name;
            this.editmode = true;
        } else {
            this.editmode = false;
            this.$emit("rename", this.tempname);
        }
    }

}
